import ServicePageTemplate from './ServicePageTemplate';
import { digitalMarketingCourseModasaConfig } from './trainingPageConfigs';

const DigitalMarketingCourseModasa = () => <ServicePageTemplate {...digitalMarketingCourseModasaConfig} />;

export default DigitalMarketingCourseModasa;